import BasicResource from '@/api/resource';

class TspResource extends BasicResource {

    constructor () {
        super('proxies');
    }

    list (params) {
        return this.client.request ({
            method: 'get',
            path: '/upyield/v1/offer-checker/proxies',
            params: params,
        });
    }

    get (id) {
        return this.client.request ({
            method: 'get',
            path: `/upyield/v1/offer-checker/proxies/${id}`,
        });
    }
}

export default new TspResource;
